import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { 
  Tabs,
  Toast 
} from 'antd-mobile/lib';
import Util from '../../../util'
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentFundList } from '../../../action/myAssets/InvestPlanAction';

import ProductInfo from '../../product/component/ProductInfo';
import ChannelNav from '../../ChannelNav';
import {
  getPayAll,
  getPayAllSuper
} from '../../../getPay';
import { getPublicProductDetil } from '../../../action/productAction'
import ModalSelect from '../../Modal/ModalSelect';
import {getSuperFundProductIncome} from '../../../action/portfolioAction'
const TabPane = Tabs.TabPane;
function callback(key) {
  console.log(key);
}
class InvestmentFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerValue:'',
      source0:[],
      source1:[],
      source2:[],
      source3:[],
      source4:[],
      source5:[],
      source6:[],
      source7:[],
      source8:[],
      source9:[],
      searchSouse:[],
      firstOpen:true,
      searchFlag:false
    };
  }
  componentWillMount(){
    document.title= "选择定投基金";
    let { 
      dispatch, 
      TransformationFunList
    } = this.props;
    dispatch(getInvestmentFundList((...arr)=>this.dataSouse(...arr)))
  }
  dataNode=[]
  dataSouse(...arr){
    console.log(arr)
    this.setState({
      source0:arr[0],
      source1:arr[1],
      // source2:arr[2],
      // source3:arr[3],
      // source4:arr[4],
      // source5:arr[5],
      // source6:arr[6],
      // source7:arr[7],
      // source8:arr[8],
      // source9:arr[9],
      firstOpen:false
    })
    this.dataNode=arr
  }
  selectFund = (item) => {
    let productType;
    if (item.fundTypeName=="超级基金型") {
      productType='Z'
    } else if(item.raiseMethod=='9'){
      productType='G'
    }else if(item.raiseMethod=='7'){
      productType='S'
    }else if(item.raiseMethod=='5'){
      productType='J'
    }
    
    if (item.fundTypeName=="超级基金型") {
        let inData = {
          superFundCode:item.fundCode,
          periodType:12
        }
        this.props.dispatch(getSuperFundProductIncome(inData,(data)=>{
          let leng = data.incomeDateList.length - 1;
          let IncomeDate = data.incomeDateList[leng] /*最新收益率时间*/
          let ThreeIncome = data.incomeList[leng];
          let params={
            fundName:item.name,
            fundCode:item.fundCode,
            ThreeIncome:ThreeIncome?Util.fomatFloat(ThreeIncome*100):'',
            dayIncomeDate:IncomeDate?IncomeDate.replace(/\//g,"-"):'',
            productType: "Z",
            pageText: "新建定投计划",
            superTypeValue: Util.superFundCodeArrByTarget.indexOf(item.fundCode) != -1 ? "1" : "0",
          };
          getPayAllSuper(window.history.length,params,hashHistory,"PaymentAllSuperFund")
        },this))
      }else{
      let params={
        fundName:item.name,
        fundCode:item.fundCode,
        businessType:'T039',
        productType:productType,
        titleHeader:'新建定投计划',
        wanfenshouyi:item.wanfenshouyi ? item.wanfenshouyi : "",
        fundType:item.fundTypeName,
        currentNav:item.currentNav,
        currentNavDate:item.currentNavDate,
        item:item
      };
      getPayAll(window.history.length,params,hashHistory,"FixedInvestment")
    }
     
  }
  serchChange(e){
    this.setState({
      serchVal:e.target.value
    })
  }

  goBack = () => {
    hashHistory.goBack();
  }

  getSearchList(){
    let {source0,headerValue}=this.state;
    if (headerValue=='') {
      this.setState({
        searchFlag:false,
        searchSouse:[]
      })
    } else {
      let newArr = source0.filter((item)=>{
        if(item.fundCode.toUpperCase().indexOf(headerValue.toUpperCase())>-1||item.name.toUpperCase().indexOf(headerValue.toUpperCase())>-1){
          return item
        }
      })
      this.setState({
        searchFlag:true,
        searchSouse:newArr
      })
    }
  }

  focusText = () => {
    document.onkeydown=(event) => {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if(e && e.keyCode == 13) {
        this.getSearchList();
      }
    }   
  }

  changeVale = (event) => {
    this.setState({
      headerValue: event.target.value
    });
  }

  blurText = () => {
    document.onkeydown=(event) => {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if(e && e.keyCode == 13) {
        
      }
    }   
  }
  render(){
    let fundLength=this.props.inInvestmentFundList.content.length;
    let { source0,source1,source2,source3,source4,source5,source6,source7,searchFlag,searchSouse,firstOpen,headerValue} = this.state;
    let _this = this;
    return (
        <div className="container plan-content" >
          <ModalSelect/>
          <NavigatorMain>
            <div className="boxHeader SearchList-content">
              <input autoComplete="off" onBlur={this.blurText} onFocus={this.focusText} onChange={this.changeVale} value={this.state.searchValue} placeholder="请输入基金名称或代码" type="text" />
              <span onClick={this.goBack}>取消</span>
            </div>
          </NavigatorMain>
          <div className='content'>
          { 
            searchFlag?
            <div style={{overflow: "auto", overflowX: "hidden"}}>
              {
                searchSouse.map((item,i) => {
                  if (item.fundTypeName=='超级基金型') {
                   return(
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                        fundName={item.name}
                        valName={'近一年收益'}
                        // val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                        val={item.fundCode !='SF1038' && item.fundCode !='SF1060' && item.fundCode !='SF1067' ?Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%':'--'}
                        valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                        rateName={'日涨跌幅'}
                        rate={item.fundCode !='SF1038' && item.fundCode !='SF1060' && item.fundCode !='SF1067' ?`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`:'--'}
                        // rate='--'
                      />
                    )
                  }else  if(item.fundTypeName=='货币型'||item.fundTypeName=='理财型'){
                    return(
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                        fundName={item.name}
                        valName={'万份收益'}
                        val={Util.fomatFloat(item.wanfenshouyi,4)}
                        valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                        rateName={'七日年化'}
                        rate={`${Util.fomatFloat(item.qirinianhua,3)}`}
                      />
                    )
                  }else {
                    return(
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                        fundName={item.name}
                        valName={'最新净值'}
                        val={Util.fomatFloat(item.currentNav,3)}
                        valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                        rateName={'日涨跌幅'}
                        rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                      />
                    )
                  }
                })
              }
            </div>
            :firstOpen?null:
            <Tabs  defaultActiveKey="1" type="card" animated={false} onChange={callback}>
              <TabPane tab=" " key="1">
              <div className='plan-content-box'>
              {
                source0.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      {
                        item.fundTypeName=='超级基金型'?
                        <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'近一年收益'}
                          // val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                          val={item.fundCode !='SF1038' && item.fundCode !='SF1060' && item.fundCode !='SF1067' ?Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%':'--'}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          // rate={`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`}
                          rate={item.fundCode !='SF1038' && item.fundCode !='SF1060' && item.fundCode !='SF1067' ?`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`:'--'}
                        />
                        :item.fundTypeName=='货币型'||item.fundTypeName=='理财型'?
                        <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'万份收益'}
                          val={Util.fomatFloat(item.wanfenshouyi,4)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'七日年化'}
                          rate={`${Util.fomatFloat(item.qirinianhua,3)}`}
                        />:
                        <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'最新净值'}
                          val={Util.fomatFloat(item.currentNav,3)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                        />
                      }
                    </div>
                  )
                })
              }
              {
                source0.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </div>
              </TabPane>
              {/* <TabPane tab="智投" key="2">
              {
                source1.map( (item,i)=> {
                  return(
                    <div  key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'近一年收益'}
                          // val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                          val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          // rate={`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`}
                          rate={`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source1.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="股票型" key="3">
              {
                source2.map( (item,i)=> {
                  return(
                    <div  key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'最新净值'}
                          val={Util.fomatFloat(item.currentNav,3)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source2.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="QDII基金" key="4">
               {
                source3.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'最新净值'}
                          val={Util.fomatFloat(item.currentNav,3)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source3.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="债券型" key="5">
              {
                source4.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'最新净值'}
                          val={Util.fomatFloat(item.currentNav,3)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source4.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="货币型" key="6">
              {
                source5.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'万份收益'}
                          val={Util.fomatFloat(item.wanfenshouyi,4)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'七日年化'}
                          rate={`${Util.fomatFloat(item.qirinianhua,3)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source5.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="指数型" key="7">
              {
                source6.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                          fundName={item.name}
                          valName={'最新净值'}
                          val={Util.fomatFloat(item.currentNav,3)}
                          valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                          rateName={'日涨跌幅'}
                          rate={`${Util.fomatFloat(item.zhangdiefu,2)}`}
                        />
                    </div>
                  )
                })
              }
              {
                source6.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane>
              <TabPane tab="理财型" key="8">
              {
                source7.map( (item,i)=> {
                  return(
                    <div className='planfund-info' key={`invest${i}`}>
                      <ProductInfo  singlePoint={()=>{_this.selectFund(item)}}
                        fundName={item.name}
                        valName={'万份收益'}
                        val={Util.fomatFloat(item.wanfenshouyi,4)}
                        valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                        rateName={'七日年化'}
                        rate={`${Util.fomatFloat(item.qirinianhua,3)}`}
                      />
                    </div>
                  )
                })
              }
              {
                source7.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
              }
              </TabPane> */}
            </Tabs>
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
   inInvestmentFundList:state.InvestPlanReducer.inInvestmentFundList,
   fundPublicProductDetil:state.fundPublicProductDetil,
  }
}
export default connect(mapStateToProps)(InvestmentFund);



// WEBPACK FOOTER //
// ./src/components/myAssets/investPlan/InvestmentFund.js